export const State = {
    /**
     * Нет активных сессий
     */
    idling: "idling",

    /**
     * активно более одной сессии
     */
    activeMultiple: "activeMultiple",

    empty: ""

} as const;

export type State = typeof State[keyof typeof State];